import { Buyer } from '@40seas/entities/buyers';
import { Omit, Partial, With } from '@40seas/entities/common';
import { Invoice } from '@40seas/entities/invoices';
import { z } from 'zod';

export class CreateInvoiceIntentDto extends With(
    Partial(Omit(Invoice, ['buyer'])),
    z.object({
        buyer: z.string().or(Buyer['schema'].partial()),
    }),
) {
    buyer: string | Partial<Buyer>;
}
